var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.minimum || !!_vm.maximum,
        label: _vm.prefix + "年収",
        half: "",
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.internalMinimum,
            expression: "internalMinimum",
          },
        ],
        staticClass: "boss-input",
        class: { "is-invalid-input": _vm.isInvalid },
        staticStyle: { width: "6em" },
        attrs: {
          type: "number",
          max: "99999",
          min: "0",
          "data-test": "minimum",
        },
        domProps: { value: _vm.internalMinimum },
        on: {
          keypress: function ($event) {
            return _vm.onlyNumberInRange($event, 99999)
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.internalMinimum = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("万円")]),
      _vm._v("\n  〜\n  "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.internalMaximum,
            expression: "internalMaximum",
          },
        ],
        staticClass: "boss-input",
        class: { "is-invalid-input": _vm.isInvalid },
        staticStyle: { width: "6em" },
        attrs: {
          type: "number",
          max: "99999",
          min: "0",
          "data-test": "maximum",
        },
        domProps: { value: _vm.internalMaximum },
        on: {
          keypress: function ($event) {
            return _vm.onlyNumberInRange($event, 99999)
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.internalMaximum = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("万円")]),
      _vm._v(" "),
      _vm.isInvalid
        ? _c("validation-label", {
            attrs: {
              label: "正しい大小関係で範囲を入力してください。",
              "data-test": "validation",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }